import { render, staticRenderFns } from "./DYDragDivider.vue?vue&type=template&id=323cc698&scoped=true"
import script from "./DYDragDivider.vue?vue&type=script&lang=js"
export * from "./DYDragDivider.vue?vue&type=script&lang=js"
import style0 from "./DYDragDivider.vue?vue&type=style&index=0&id=323cc698&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323cc698",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/app/jenkins/data/workspace/TEST测试环境/xcommunity-test/syx-web-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('323cc698')) {
      api.createRecord('323cc698', component.options)
    } else {
      api.reload('323cc698', component.options)
    }
    module.hot.accept("./DYDragDivider.vue?vue&type=template&id=323cc698&scoped=true", function () {
      api.rerender('323cc698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DYMainContainer/DYDragDivider.vue"
export default component.exports